import React, { Component } from 'react'
import { connect } from 'react-redux'

import ExcoDecision from './component'
import CenteredSpinner from '../../Atoms/Spinner/CenteredSpinner'

import { fetchDecision, submitDecision } from '../../../redux/exco'

class ExcoDecisionContainer extends Component {
  componentDidMount () {
    this.props.fetchDecision(this.props.teamNumber, this.props.selectedRound)
  }

  componentDidUpdate (prevProps) {
    if (this.props.isCurrentTab && !prevProps.isCurrentTab) {
      return this.props.fetchDecision(this.props.teamNumber, this.props.selectedRound)
    }
    if (this.props.selectedRound !== prevProps.selectedRound || this.props.roundNumber !== prevProps.roundNumber || this.props.teamNumber !== prevProps.teamNumber) {
      return this.props.fetchDecision(this.props.teamNumber, this.props.selectedRound)
    }
  }

  shouldComponentUpdate (nextProps) {
    if (!nextProps.isCurrentTab) {
      return false
    }
    return true
  }

  handleDecisionChange = (decision) => {
    this.props.submitDecision(this.props.teamNumber, this.props.selectedRound, decision)
  }

  render () {
    if (this.props.isLoading) {
      return <CenteredSpinner />
    }

    return (
      <ExcoDecision
        id={this.props.id}
        name={this.props.name}
        description={this.props.description}
        options={this.props.options}
        decision={this.props.decision}
        onDecisionChange={this.handleDecisionChange}
        canSelect={this.props.selectedRound === this.props.roundNumber}
        sidebarWidth={this.props.sidebarWidth}
        error={this.props.error ? this.props.error.message : null}
        content={this.props.content}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  isCurrentTab: state.ui.currentTab === 'ExcoDecision',
  sidebarWidth: state.ui.sidebarWidth,
  selectedRound: state.game.selectedRound,
  teamNumber: state.team.id,
  roundNumber: state.game.currentRound,
  error: state.exco.error,
  isLoading: state.exco.isLoading,
  isLoaded: state.exco.isLoaded,
  id: state.exco.id,
  name: state.exco.name,
  description: state.exco.description,
  options: state.exco.options,
  decision: state.exco.decision,
  isSubmitting: state.exco.isSubmitting,
  isMaster: state.device.isMaster
})

export default connect(mapStateToProps, { fetchDecision, submitDecision })(ExcoDecisionContainer)
